// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"app-icon_imageContainer__2DjLH","titleContainer":"app-icon_titleContainer__3uFJa","title":"app-icon_title__3iQZ-"};